import React from 'react';
import './Mission.css';

import { Heading } from '../../../components';
import { mission } from '../../../constants';



const Mission = () => {

  return (
    <section className="custom-form our-mission">
      <div className="box-container">
        <div className="content">
          <div className="text">

            {/* Section Heading */}
            <Heading title={mission.heading} subTitle={mission.sub} sideHeading linear />

            <p>{mission.content}</p>

            {/* Key Mission Points */}
            <div className="mission-points">
              {mission.points.map((point) => (
                <div className="box" key={point.id}>
                  <h3>
                    {point.title}
                    <span> {point.progress}% </span>
                  </h3>
                  <div className="progress-bar">
                    <span style={{ width: `${point.progress}%` }}></span>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;